import React, {Suspense, useEffect, useState} from "react";
import Button from "./component-assets/Button.jsx";
import ApiRequester from "./ApiRequester.jsx";
import {
    paginateData, sortFunc, handleSubmitActions, actionAppearance, checkAll, formSuccess, showModal, isBannerPresent,
    headerFilterFunc, searchFunc
} from "../libs.jsx"
import {ToastContainer} from "react-toastify";
import {CSVLink} from "react-csv";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import Navigation from "./Navigation.jsx";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton.jsx";
import { getSession, setSession } from "../services/session";

const AllServers = (props) => {
    let dData, bData, headerData, csvHeaders;

    headerData = [
        {label: "Campus Name", key: "campus_name", align: "left", filtered: true,
            link: {enabled: true, linkto: "/profiles/campus", linkkey: "campus_id"}},
        {label: "Corporation", key: "corporate_name", align: "left", filtered: true,
            link: {enabled: true, linkto: "/profiles/corporate", linkkey: "corporate_id"}},
        {label: "Checkin Time", key: "checkin_time", align: "center", type: "datetime"},
        {label: "Recent Alarm Time", key: "recent_alarm_input_time", align: "center", type: "datetime"},
        {label: "Recent Alarm Bytes Raw", key: "recent_alarm_input_raw", align: "left", wrap: "break-all"},
        {label: "Recent Alarm Bytes Parsed", key: "recent_alarm_input_parsed", align: "left"},
        {label: "DB Version", key: "version_database", align: "center", filtered: true},
        {label: "Code Version", key: "version_code", align: "center", filtered: true},
    ];

    csvHeaders = [
        {label: "Campus ID", key: "campus_id"},
        {label: "Campus Name", key: "campus_name"},
        {label: "Corporation ID", key: "corporate_id"},
        {label: "Corporation Name", key: "corporate_name"},
        {label: "Code Version", key: "version_code"},
        {label: "Checkin Time", key: "checkin_time"},
        {label: "Recent Alarm Time", key: "recent_alarm_input_time"},
        {label: "DB Version", key: "version_database"}
    ];

    dData = getSession();

    // Main Table Data Variables
    const [dataOrigin, setDataOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [read, setRead] = useState(true);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    // Main Table Control Variables
    const [count, setCount] = useState(0);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [search, setSearch] = useState("");
    const [headerFilters, setHeaderFilters] = useState([]);
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter, setSorter] = useState({
        sortColumn: "campus_name",
        sortOrder: "asc"
    });
    // Other Enact Once Variables
    const [csvLink, setLink] = useState({
        filename: "all_servers.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                payload: {campus_filter: ""}, procedure: "getpalcaredevices", reqType: "stored"}).then(data => {
                setDataOrigin(data ? data : []);
                setOriginLoaded(true);
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={false}
                                writeAccess={false} unk={"a-"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                tableHeaders={headerData} editModal={() => {}} modal={false} parentComponent={"Customers"}
                                dData={dData} checkboxlist={[]} modalType={""} corpId={dData?.corp}
                                setCheckboxId={() => {}} checkidkey={"campus_id"} />);
    }, [activeData, sorter, page, perPage]);

    useEffect(() => {
        setLink(prevState => {
            return {...prevState,
                headers: csvHeaders,
                data: dataOrigin}
        });
    }, [dataOrigin]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        );
    }, [csvLink]);

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(dataOrigin, headerFilters, headerData);

        searchKeys = ["campus_name", "corporate_name", "checkin_time", "version_code", "version_database",
            "recent_alarm_input_time"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [search, dataOrigin, headerFilters]);

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        dData.perPage = tmpPerPage;
        setPage(1);
        setSession(dData);
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    const tableHeaders = <TableHeaders checkbox={false} headerData={headerData} checkAll={() => checkAll(ppRules.start, ppRules.end, [], () => {})}
                                       writeAccess={false} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead"} originData={dataOrigin} headerFiltersOn={true}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} modal={false} checkboxlist={[]}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn"])}
                                       headerFilters={headerFilters} setHeaderFilters={setHeaderFilters} setPage={setPage} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"}
                            style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                </div>
                {csvButton}
            </div>
        </div>
    );

    const footer = (
        <div>
            <Pagination>
                <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                 endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                 max={ppRules.max}/>
            </Pagination>
            <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Customers"} Title={"Servers"} content={headerContent}/>
                <div className={"container-fluid mt-4"}>
                    {!pageLoaded
                        ?   skeleton
                        :   <table className={"table table-sm table-white table-hover"}>
                                <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {tableHeaders}
                                </thead>
                                <tbody id={"tBody"}>
                                    {tableRows}
                                </tbody>
                            </table>
                    }
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer}/>
            </div>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage} setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)} setPage={(sudocode) => setPage(sudocode)}/>
            <button type={"button"} className={"help-corner-button"} onClick={() => showModal("helpmodal")}
                    title={"Page Help Popup"} aria-label={"Open Help"}>
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>All Servers Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The All Servers page provides a comprehensive overview of all server devices across all campuses in your organization. 
                                    This page allows you to monitor server status, check-in times, recent alarm activity, and version information.
                                </p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-list me-2 text-primary"}></i>Server Information Table
                                </h5>
                                <p className={"mb-2"}>The main table displays server information with the following columns:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Campus Name</strong>: The name of the campus where the server is located (clickable link to campus profile)</li>
                                    <li className={"mb-2"}><strong>Corporation</strong>: The corporation that owns the campus (clickable link to corporate profile)</li>
                                    <li className={"mb-2"}><strong>Checkin Time</strong>: The last time the server checked in with the system</li>
                                    <li className={"mb-2"}><strong>Recent Alarm Time</strong>: The timestamp of the most recent alarm received by the server</li>
                                    <li className={"mb-2"}><strong>Recent Alarm Bytes Raw</strong>: The raw byte data from the most recent alarm (wrapped for readability)</li>
                                    <li className={"mb-2"}><strong>Recent Alarm Bytes Parsed</strong>: The parsed/interpreted version of the recent alarm data</li>
                                    <li className={"mb-2"}><strong>DB Version</strong>: The database version running on the server</li>
                                    <li className={"mb-2"}><strong>Code Version</strong>: The software code version running on the server</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-search me-2 text-primary"}></i>Searching and Filtering
                                </h5>
                                <p className={"mb-2"}>Use the search and filter options to find specific servers:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Search Bar</strong>: Use the search bar to quickly find servers by campus name, corporation name, check-in time, code version, database version, or recent alarm time</li>
                                    <li className={"mb-2"}><strong>Column Filters</strong>: Click the filter icons in column headers to filter by specific criteria for that column</li>
                                    <li className={"mb-2"}>Filters can be combined to narrow down results</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-chevron-up me-2 text-primary"}></i>
                                    <i className={"fe fe-chevron-down me-2 text-primary"}></i>Sorting
                                </h5>
                                <p className={"mb-2"}>You can sort the table by clicking on column headers:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Click once to sort in ascending order</li>
                                    <li className={"mb-2"}>Click again to sort in descending order</li>
                                    <li className={"mb-2"}>The default sort is by Campus Name in ascending order</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-download me-2 text-primary"}></i>Exporting Data
                                </h5>
                                <p className={"mb-2"}>You can export server data for external analysis:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Click the <strong>"Export"</strong> button to download all server data as a CSV file</li>
                                    <li className={"mb-2"}>The export includes: Campus ID, Campus Name, Corporation ID, Corporation Name, Code Version, Check-in Time, Recent Alarm Time, and DB Version</li>
                                    <li className={"mb-2"}>The exported data reflects the current filtered and sorted view</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-clock me-2 text-primary"}></i>Monitoring Server Health
                                </h5>
                                <p className={"mb-2"}>Use this page to monitor server health and activity:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Check-in Time</strong>: Monitor how recently servers have checked in. Servers that haven't checked in recently may indicate connectivity issues</li>
                                    <li className={"mb-2"}><strong>Recent Alarm Time</strong>: Shows when the server last processed an alarm, indicating active system operation</li>
                                    <li className={"mb-2"}><strong>Version Information</strong>: Compare DB Version and Code Version across servers to ensure consistency</li>
                                    <li className={"mb-2"}><strong>Alarm Data</strong>: Review recent alarm bytes (raw and parsed) to troubleshoot communication issues</li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Use pagination controls at the bottom to navigate through multiple pages of servers</li>
                                    <li className={"mb-2"}>Adjust the number of items displayed per page using the page size button</li>
                                    <li className={"mb-2"}>Click on campus names to navigate to campus profile pages</li>
                                    <li className={"mb-2"}>Click on corporation names to navigate to corporate profile pages</li>
                                    <li className={"mb-2"}>The page automatically refreshes every 10 minutes to show the latest server data</li>
                                    <li className={"mb-2"}>Use the search and filter features together to quickly locate specific servers or troubleshoot issues</li>
                                    <li className={"mb-2"}>Monitor check-in times regularly to ensure all servers are communicating properly with the system</li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default AllServers;